import { httpRequest } from "../../../utils/HttpRequest";
import {
    ISaleRoSearch,
    ISaleRoDetail,
    ISaleRoFields,
    ISaleRoList,
    Detailed,
    IInvalidate,
    ISaleSoDetailsSearch,
    ISaleSoDetails,
    ISaleRoPoSettleAndWhConfirm,
    ISaleRoSettleParams,
    ISaleRoStatistics
} from "./saleRoTypes"
import { IPage } from "@/types/ScmTypes";

class SaleRoService {
    async page(searchVo: ISaleRoSearch) {
        const apiUrl = "/zzw-vrm/sreturn/findPage";
        return await httpRequest.post<ISaleRoList>(apiUrl, searchVo);
    }
    async total(searchVo: ISaleRoSearch) {
        const apiUrl = "/zzw-vrm/sreturn/total";
        return await httpRequest.post<ISaleRoStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/sreturn/findById/${id}`;
        return await httpRequest.get<ISaleRoDetail>(apiUrl);
    }

    async insert(insertVo: ISaleRoFields) {
        const apiUrl = "/zzw-vrm/sreturn/insert";
        return await httpRequest.post<ISaleRoDetail>(apiUrl, insertVo);
    }
    async update(updateVo: ISaleRoFields) {
        const apiUrl = "/zzw-vrm/sreturn/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/zzw-vrm/sreturn/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: ISaleRoFields) {
        const apiUrl = "/zzw-vrm/sreturn/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //转销售单
    async transfer(planCode: string) {
        const apiUrl = `/zzw-vrm/sreturn/transfer/${planCode}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    // //详情导入
    // async invalidate(){
    //     const apiUrl = "/zzw-vrm/sreturn/detail/downloadTpl";
    //     return await httpRequest.getFile<boolean>(apiUrl);
    // }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/zzw-vrm/sreturn/detail/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
    //作废
    async invalidate(params: IInvalidate) {
        const apiUrl = "/zzw-vrm/sreturn/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //库房确认
    async warehousing(params: ISaleRoPoSettleAndWhConfirm) {
        const apiUrl = "/zzw-vrm/sreturn/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //销售结算
    async settle(params: ISaleRoSettleParams) {
        const apiUrl = "/zzw-vrm/sreturn/settlePro";
        // const apiUrl = "/zzw-vrm/sreturn/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //销售退货查询详情
    async saleDetails(params: ISaleSoDetailsSearch) {
        const apiUrl = "/zzw-vrm/sale/details/findPage";
        return await httpRequest.post<IPage<ISaleSoDetails>>(apiUrl, params);
    }
    //详情导出
    async detailsExport(params: ISaleRoFields) {
        const apiUrl = "/zzw-vrm/sreturn/detailsExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/zzw-vrm/sreturn/print/${id}`;
        return await httpRequest.get(apiUrl);
    }
}

export const saleRoService = new SaleRoService();